import React, { useState, useEffect } from "react";
import Icon from "../../../../../../common/Icon";
import SurveyLoader from "../components/SurveysLoader.js";
import {
  CloseButton,
  CompletedSurveyActionButton,
  CompletedSurveyCloseButton,
  CompletedSurveyContainer,
  CompletedSurveyContent,
  CompletedSurveyRoleBadge,
  CompletedSurveyTable,
  CompletedSurveyTableCell,
  CompletedSurveyTableHeader,
  CompletedSurveyTableRow,
  ModalCloseHeader,
  ModalHeader,
  ModalOverlay,
  ModalTitle,
  NotFoundContainer,
  NotFoundMessage,
  SurveyTableOuter,
  IconWrapper,
} from "../styles.js";
import Loading from "../../../../../../common/Loading/index.js";
import { SearchContainer } from "../styles.js";
import { SearchInput } from "../styles.js";
import { useNavigate } from "react-router-dom";

const CompletedSurveyListModal = ({
  completedSurveys,
  setCompletedSurveys,
  handleViewSurveyResponse,
  setShowSurveyModal,
  completedSurveyLoading,
}) => {
  const [originalSurveys, setOriginalSurveys] = useState([]);
  const navigate = useNavigate();
  const searchByNameHandler = (event) => {
    const { value } = event.target;

    if (!value) {
      setCompletedSurveys(originalSurveys);
      return;
    }

    const data = originalSurveys?.filter?.((survey) => {
      return (
        survey?.user?.firstName?.toLowerCase().includes(value.toLowerCase()) ||
        survey?.user?.lastName?.toLowerCase().includes(value.toLowerCase())
      );
    });

    setCompletedSurveys(data);
  };

  const handleCloseModal = () => {
    setShowSurveyModal(false);
    setCompletedSurveys(null);
  };

  useEffect(() => {
    if (completedSurveys?.length && originalSurveys.length === 0) {
      setOriginalSurveys(completedSurveys);
    }
  }, [completedSurveys]);

  const showFormattedDate = (date) => {
    return new Date(date).toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // You can set this to false for 24-hour time format
    });
  };

  return (
    <ModalOverlay onClick={handleCloseModal}>
      <CompletedSurveyContainer onClick={(e) => e.stopPropagation()}>
        {/* header */}
        <ModalHeader>
          <ModalTitle>Completed Survey</ModalTitle>
          <ModalCloseHeader>
            <CloseButton onClick={handleCloseModal}>
              <span>
                <Icon type="close"></Icon>
              </span>
            </CloseButton>
          </ModalCloseHeader>
        </ModalHeader>
        {/* main content  */}
        {completedSurveyLoading ? (
          <CompletedSurveyContent>
            <Loading loadingItem="Surveys" />
          </CompletedSurveyContent>
        ) : (
          <CompletedSurveyContent>
            {/* search container */}
            <SearchContainer>
              <SearchInput
                type="text"
                placeholder="Search user by name"
                onChange={(event) => searchByNameHandler(event)}
              />
              <Icon type="search-icon"></Icon>
            </SearchContainer>
            {/* Table  */}
            {completedSurveys?.length > 0 ? (
              <SurveyTableOuter>
                {completedSurveys ? (
                  <CompletedSurveyTable>
                    <thead>
                      <tr>
                        <CompletedSurveyTableHeader>
                          Full Name
                        </CompletedSurveyTableHeader>
                        <CompletedSurveyTableHeader>
                          Role
                        </CompletedSurveyTableHeader>
                        <CompletedSurveyTableHeader>
                          Date Completed
                        </CompletedSurveyTableHeader>
                        <CompletedSurveyTableHeader>
                          Action
                        </CompletedSurveyTableHeader>
                      </tr>
                    </thead>
                    <tbody>
                      {completedSurveys.map((item) => {
                        return (
                          <CompletedSurveyTableRow key={item.id}>
                            <CompletedSurveyTableCell>
                              <img
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  borderRadius: "50%",
                                }}
                                src={item?.user?.image}
                                alt=""
                              />
                              <span>
                                {item?.user
                                  ? item?.user?.firstName +
                                    " " +
                                    item?.user?.lastName
                                  : // : `Anonymous ${item.survey?.assignedTo}`}
                                    `Anonymous User`}
                              </span>
                            </CompletedSurveyTableCell>
                            <CompletedSurveyTableCell>
                              <CompletedSurveyRoleBadge
                                role={item.joinedProgramAs}
                              >
                                {item?.user ? item?.survey?.assignedTo : "N/A"}
                              </CompletedSurveyRoleBadge>
                            </CompletedSurveyTableCell>
                            <CompletedSurveyTableCell>
                              {showFormattedDate(item.createdAt)}
                            </CompletedSurveyTableCell>
                            <CompletedSurveyTableCell>
                              <IconWrapper
                                onClick={() => {
                                  navigate("/messages/" + item?.user?.uuid);
                                }}
                              >
                                <Icon type="comment"></Icon>
                              </IconWrapper>

                              <CompletedSurveyActionButton
                                onClick={() => handleViewSurveyResponse(item)}
                              >
                                View More
                              </CompletedSurveyActionButton>
                            </CompletedSurveyTableCell>
                          </CompletedSurveyTableRow>
                        );
                      })}
                    </tbody>
                  </CompletedSurveyTable>
                ) : (
                  <SurveyLoader text={"Completed Surveys"} />
                )}
              </SurveyTableOuter>
            ) : (
              <NotFoundContainer>
                <NotFoundMessage>No Completed Survey Found</NotFoundMessage>
              </NotFoundContainer>
            )}
            {/* footer */}
            <CompletedSurveyCloseButton onClick={handleCloseModal}>
              Close
            </CompletedSurveyCloseButton>
          </CompletedSurveyContent>
        )}
      </CompletedSurveyContainer>
    </ModalOverlay>
  );
};

export default CompletedSurveyListModal;
